import React, { useContext } from 'react'
import { ModalContext } from '../../contexts/ModalContext.js';
import './infomodal.scss';

const InfoModal = () => {

	const { setIsInfoModalOpen } = useContext(ModalContext)

	return (
		<div className="info-modal">
			<div className='info-modal-content'>
				<h2><i className="bi bi-exclamation-triangle-fill"></i> WARTUNGSARBEITEN <i className="bi bi-exclamation-triangle-fill"></i></h2>
				<div className='info-modal-text'>
					<p>Liebe NEXARK-Community,</p>
					<p>Vom 23. April bis vorraussichtlich 5. Mai 2026 finden Wartungsarbeiten im Rechenzentrum statt, die Server werden während dieser Zeit nicht verfügbar sein. Ein Backup der Server wird am 22. April erstellt. Wir haben darauf leider keinen Einfluss und können nur abwarten, aber danken euch für euer Verständnis.</p>
				</div>
			</div>
			<p className='info-button' onClick={(e) => {setIsInfoModalOpen(false); e.preventDefault()}}>Verstanden</p>
		</div>
	)
}

export default InfoModal;